<template>
  <modal
    class="createAssetGroup"
    name="rejectSupply"
    transition="pop-out"
    :width="800"
    :height="300"
  >
    <div class="text-center assets_modal_div branch_assets_modal">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">
        {{ $t("text.dryStockModal.rejectionReason") }}
      </p>
      <form>
        <div class="modal_form_field bas">
          <label class="assets_label required">{{
            $t("text.dryStockModal.rejectionReason")
          }}</label>
          <textarea
            :disabled="rejectionReason ? true : false"
            type="text"
            rows="4"
            class="form-control"
            v-model="reason"
          ></textarea>
        </div>
        <button
          @click="rejectSupply($event)"
          class="assets_button bas"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
          v-if="!rejectionReason"
        >
          {{ $t("text.dryStockModal.rejectSupply") }}
          <img
            src="@/assets/img/git_loader.gif"
            width="20px"
            class="ml-3 loader"
            v-if="showLoader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";

export default {
  name: "rejectSupply",
  props: ["supplyId", "branchId", "rejectionReason"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      reason: "",
    };
  },
  watch: {
    rejectionReason() {
      this.reason = this.rejectionReason;
    },
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  mounted() {},
  methods: {
    opened() {},
    closeModal() {
      this.$modal.hide("rejectSupply");
    },
    rejectSupply($event) {
      $event.preventDefault();
      if (!this.reason) {
        this.$toast.open({
          message: error.response.data.message,
          type: "error",
          duration: 5000,
        });
        return;
      }
      this.showLoader = true;
      this.isButtonDisabled = true;
      const deleteConfirm = window.confirm(
        "Are you sure you want to reject this supply?"
      );
      if (deleteConfirm) {
        this.axios
          .post(
            `${configObject.apiBaseUrl}​/NonWetProductSupply/RejectSupply/${this.branchId}/${this.supplyId}`,
            { reason: this.reason },
            configObject.authConfig()
          )
          .then(() => {
            this.closeModal();
            this.showLoader = false;
            this.isButtonDisabled = false;
            this.$toast.open({
              message: this.$t("text.dryStockModal.successMsg"),
              type: "success",
              duration: 5000,
            });
            this.$eventHub.$emit("renderNonWetProductSupplies");
          })
          .catch((error) => {
            this.showLoader = false;
            this.isButtonDisabled = false;
            this.$toast.open({
              message: error.response.data.message,
              type: "error",
              duration: 5000,
            });
          });
      }
    },
  },
};
</script>
